import React from "react";
import "./CAFCHeroSection.css";

const CAFCHeroSection = ({ cmsData }) => {
  return (
    <section className="cafc-hero-section">
      <div className="cafc-hero-overlay">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="cafc-hero-title">{cmsData?.pageTitle}</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CAFCHeroSection;